(function () {
  if (window.__customMenuToggleInit) return;
  window.__customMenuToggleInit = true;

  function init() {
    var toggle = document.getElementById('site-menu-handle');
    var header = document.getElementById('site-header');
    if (!toggle || !header) return;

    function setOpen(isOpen) {
      header.classList.toggle('is-menu-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(!header.classList.contains('is-menu-open'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('is-menu-open')) {
        setOpen(false);
        toggle.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (header.classList.contains('is-menu-open') && !header.contains(e.target)) {
        setOpen(false);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
